import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import Helper from "../../support/Helper";
import AxiosIndicator from "@system/chain/axios-indicator";
import StoreInner from "../../storeWire";

export const set_axios_indicator = createAsyncThunk('system__set_axios_indicator', async (running_axios_slug) => {
    let s = StoreInner.getState();
    if (AxiosIndicator.register[running_axios_slug] !== undefined) {
        let axios_indicator = {...s.entities.system.axios_indicator};
        axios_indicator[running_axios_slug] = {
            active: running_axios_slug
        };
        return axios_indicator;
    }
    return false;
});

export const remove_axios_indicator = createAsyncThunk('system__remove_axios_indicator', async (running_axios_slug) => {
    let s = StoreInner.getState();
    let axios_indicator = {...s.entities.system.axios_indicator};
    if (axios_indicator[running_axios_slug] !== undefined) {
        delete axios_indicator[running_axios_slug];
    }
    return axios_indicator;
});

const slice = createSlice({
        name: "system",
        initialState: {
            DOMAttachToSystem: {
                event: {},
                latest_event_fired: false,
                latest_event_fired_uuid: false,
                system_notification: {
                    AddedToCartNotification: false,
                    InventoryAlertForAddToCartPopup: false,
                    ContactUsPopup: false,
                    InventoryAlertPopup: false,
                    SendEmailOfReportError: false,
                    SendEmailOfCurrentPage: false,
                    toast: false,
                    AuthOnBoarding: false,
                    DefaultProfileEdit: false
                },
                latest_system_notification_name: false,
                latest_system_notification_data: false,
                latest_system_notification_UUID: false,
            },
            stateToRedux: {},
            axios_indicator: {},
        },
        reducers: {
            event: {
                reducer: (state, action) => {
                    state.DOMAttachToSystem.latest_event_fired = action.payload.event_name;
                    state.DOMAttachToSystem.latest_event_fired_uuid = Helper.UUID();
                    state.DOMAttachToSystem.event[action.payload.event_name] = {
                        event_name: action.payload.event_name,
                        event_data: action.payload.event_data
                    };
                    return state;
                },
            },
            system_notification: {
                reducer: (state, action) => {
                    let d = {
                        name: action.payload.name,
                        data: action.payload.data,
                        UUID: Helper.UUID()
                    };
                    state.DOMAttachToSystem.system_notification[action.payload.name] = d;
                    state.DOMAttachToSystem.latest_system_notification_name = d.name;
                    state.DOMAttachToSystem.latest_system_notification_data = d.data;
                    state.DOMAttachToSystem.latest_system_notification_UUID = d.UUID;

                },
            },
            setStateToRedux: {
                reducer: (state, action) => {
                    state.stateToRedux[action.payload.name] = action.payload.data;
                },
            },
        },
        extraReducers: {
            [set_axios_indicator.fulfilled]: (state, {payload}) => {
                if (payload) {
                    state.axios_indicator = payload;
                }
            },
            [remove_axios_indicator.fulfilled]: (state, {payload}) => {
                state.axios_indicator = payload;
            },
        },
    })
;

export let {event, system_notification, setStateToRedux} = slice.actions;

export default slice.reducer;
